import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useTranslation from "hooks/useTranslation";
import { getNotifMsg } from "utils/message";

const useCopyToClipboard = (textToCopy) => {
  const [doCopy, setDoCopy] = useState(false);
  const { getAppLocale } = useTranslation("COMMON");

  const copyToClipboardFallback = () => {
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "fixed";
    textArea.style.top = "-999999px";
    textArea.style.left = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((resolve, reject) => {
      const isCopied = document.execCommand("copy");
      if (!isCopied) {
        console.error("Error occured while copying to clipboard");
        // toast.error("لطفا دوباره تلاش كنيد.");
        toast.success(getNotifMsg("COPY_FAILED", getAppLocale()));
        setDoCopy(false);
        textArea.remove();
        reject();
        return;
      }
      toast.success(getNotifMsg("COPIED", getAppLocale()));
      setDoCopy(false);
      textArea.remove();
      resolve();
    });
  };

  useEffect(() => {
    if (doCopy) {
      if (!navigator.clipboard) {
        copyToClipboardFallback();
      } else {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            toast.success(getNotifMsg("COPIED", getAppLocale()));
            setDoCopy(false);
          })
          .catch((error) => {
            console.error("Error occured while copying to clipboard");
            // toast.error("لطفا دوباره تلاش كنيد.");
            toast.success(getNotifMsg("COPY_FAILED", getAppLocale()));
            setDoCopy(false);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doCopy]);

  const copyToClipboard = () => {
    setDoCopy(true);
  };

  return copyToClipboard;
};

export default useCopyToClipboard;
